<section class="main-section form-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/contacts/">Customers</a></li>
      <li aria-current="page" class="breadcrumb-item active">Edit Customer</li>
    </ol>
  </nav>
  <form>
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <h2 class="text-black">Details</h2>
          <div class="row mt-3">
            <div class="col-lg-4 col-sm-6 required">
              <label class="control-label" for="customerType">Customer Type</label>
              <span *ngIf="statusText10" class=" ml-2"></span>
              <div class="form-group ">
                <select (blur)="selectCustomerType()" [(ngModel)]="editContacts.customerType"
                        [ngClass]="{'is-invalid':statusText9}"
                        [ngModelOptions]="{standalone: true}" class="form-control"
                        id="customerType" required>
                  <option value="Sender">Sender</option>
                  <option value="Receiver">Receiver</option>
                </select>
              </div>
            </div>
            <div class="col-lg-4 col-sm-6">
              <label class="control-label" for="companyName">Company Name</label>
              <div class="form-group">
                <input [(ngModel)]="editContacts.companyName" [ngModelOptions]="{standalone: true}" class="form-control"
                       id="companyName"
                       required type="text">
              </div>
            </div>
            <div class="col-lg-4 col-sm-6 required">
              <label class="control-label" for="name">Name</label>
              <span *ngIf="statusText2" class=" ml-2"></span>
              <div class="form-group ">
                <input (blur)="createContactName()" [(ngModel)]="editContacts.contactName"
                       [ngClass]="{'is-invalid':statusText2}" [ngModelOptions]="{standalone: true}"
                       class="form-control" id="name"
                       required type="text">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4 col-sm-6 required">
              <label class="control-label" for="email">Email</label>
              <span *ngIf="statusText3" class=" ml-2"></span>
              <div class="form-group ">
                <input (blur)="createEmail()" [(ngModel)]="editContacts.email" [ngClass]="{'is-invalid':statusText3}"
                       [ngModelOptions]="{standalone: true}"
                       class="form-control" id="email"
                       required type="text">
              </div>
            </div>
            <div class="col-lg-4 col-sm-6 required">
              <label class="control-label" for="phone">Phone Number</label>
              <span *ngIf="statusText4" class=" ml-2"></span>
              <div class="form-group ">
                <input (blur)="createMobile()" [(ngModel)]="editContacts.mobile" [ngClass]="{'is-invalid':statusText4}"
                       [ngModelOptions]="{standalone: true}" class="form-control" id="phone"
                       maxlength="10" onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                       required type="text">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngFor="let add of addresses" class="row mt-3">
      <div
        *ngIf="statusText10 || statusText2 || statusText3 || statusText4 || statusText5 || statusText7 || statusText8 || statusText9"
        class="col-md-12 mb-1 text-danger fw-500">
        Please Enter Mandatory Fields
      </div>
      <div class="col">
        <ul class="list-inline tab-list">
          <li class="list-inline-item ml-2"><a (click)=" tabChange('address');"
                                               [ngClass]="{'active': tabClicked === 'address'}"
                                               class="list-inline-item">Address
            <span *ngIf="statusText5 || statusText6 || statusText7 || statusText8"
                  class="dot bg-danger ml-2"></span></a></li>
          <li class="list-inline-item ml-3"><a (click)=" tabChange('instructions');"
                                               [ngClass]="{'active': tabClicked === 'instructions'}"
                                               class="nav-link warehouses">Instructions</a>
          </li>
        </ul>
        <div *ngIf="tabClicked == 'address'" class="inner-box">
          <h2 class="text-black mb-3">Address</h2>
          <div class="row">
          </div>
          <div class="row">
            <div class="col-lg-8 col-md-12">
              <div class="row">
                <div class="col-lg-4 col-sm-4 required">
                  <label class="control-label" for="streetAddress">Address 1 </label>
                  <div class="form-group ">
                    <input (blur)="createAddress()" [(ngModel)]="add.address1" [ngClass]="{'is-invalid':statusText5}"
                           [ngModelOptions]="{standalone: true}"
                           class="form-control" id="streetAddress"
                           required type="text">
                  </div>
                </div>
                <div class="col-lg-4 col-sm-4">
                  <label for="streetAddress2">Address 2</label>
                  <div class="form-group">
                    <input [(ngModel)]="add.address2" [ngModelOptions]="{standalone: true}" class="form-control"
                           id="streetAddress2"
                           required type="text">
                  </div>
                </div>
                <div class="col-lg-4 col-sm-4 required">
                  <label class="control-label">City</label>
                  <div class="form-group ">
                    <ng-select (blur)="createCity()" [(ngModel)]="add.city" [items]="citiesList" [addTag]="true"
                               [ngClass]="{'is-invalid':statusText6}"
                               [ngModelOptions]="{standalone: true}" id="city" placeholder="City"
                               required type="text">
                    </ng-select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-4 col-sm-6 required">
                  <label class="control-label">State</label>
                  <div class="form-group ">
                    <ng-select (blur)="createState()" [(ngModel)]="add.state" [items]="statesList"
                               [ngClass]="{'is-invalid':statusText7}"
                               [ngClass]="{'service-error':statusText7}"
                               [ngModelOptions]="{standalone: true}"
                               id="State"
                               placeholder="State">
                    </ng-select>
                  </div>
                </div>
                <div class="col-lg-4 col-sm-6 required">
                  <label class="control-label" for="zip">Zip</label>
                  <div class="form-group ">
                    <input (blur)="createZip()" (change)="changeStateAndCity()" [(ngModel)]="add.zip"
                           [ngClass]="{'is-invalid':statusText8}" [ngModelOptions]="{standalone: true}"
                           class="form-control" id="zip"
                           maxlength="6" onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                           required type="text">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div *ngIf="tabClicked == 'instructions'" class="inner-box">
          <h2 class="text-black">Instructions</h2>
          <div class="row mt-3">
            <div class="col-lg-5 col-sm-6">
              <div class="required">
                <textarea [(ngModel)]="editContacts.deliveryInstructions" [ngModelOptions]="{standalone: true}"
                          class="form-control"
                          id="requestNotes" maxlength="250" required rows="6"></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</section>
<div class="form-btn-section">
  <div class="row">
    <div class="col-12 text-right">
      <button class="btn btn-cancel" id="cancel" routerLink="/admin/contacts" type="reset">Cancel</button>
      <button (click)=" submitEditContacts()" class="btn btn-orange ml-2" id="save" type="submit">Save</button>
    </div>
  </div>
</div>
